import { render, staticRenderFns } from "./MigrationTable.vue?vue&type=template&id=1bd25e79&scoped=true"
import script from "./MigrationTable.vue?vue&type=script&lang=js"
export * from "./MigrationTable.vue?vue&type=script&lang=js"
import style0 from "./MigrationTable.vue?vue&type=style&index=0&id=1bd25e79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd25e79",
  null
  
)

export default component.exports